/** 菜单 */
export default {
    frontPage: "首页", // 首页
    day: "日", // 日
    week: "周", // 周
    month: "月", // 月
    year: "年", // 年
    PCS: "台", // 设备台数
    cumulativeTrafficOverview: "累计客流概览", // 累计客流概览
        cumulativePassengerFlowToday:"今日累计客流", // 今日累计客流 Cumulative passenger flow today
        comparedToYesterday: "较昨日", // 较昨日 compared to yesterday
        cumulativePassengerFlowThisMonth: "本月累计客流", // 本月累计客流 Cumulative passenger flow this month
        comparedWithLastMonth: "较上月", // 较上月 Compared with last month
        cumulativePassengerFlowThisYear: "本年累计客流", // 本年累计客流 Cumulative passenger flow this year
        comparedToLastYear: "较去年", // 较去年 compared to last year
        cumulativePassengerFlowYesterday: "昨日累计客流", // 昨日累计客流 Cumulative passenger flow yesterday
        cumulativePassengerFlowLastMonth: "上月累计客流", // 上月累计客流 Cumulative passenger flow last month
        cumulativePassengerFlowLastYear: "去年累计客流", // 去年累计客流 Cumulative passenger flow last year
        overviewOfDeviceInformation: "设备信息概览", // 设备信息概览 Overview of device information
            onlineDevice: "在线设备", // 在线设备 online device
            offlineDevice: "离线设备", // 离线设备 offline device
            total: "总数", // 总数 total
    announcement: "通知公告", // announcement
        viewAll: "查看全部", //查看全部 view all
    entityPassengerFlow: "实体客流(只查询排行前10)", // Entity passenger flow (only query the top 10) 实体客流(只查询排行前10)
    listOfPhysicalPassengerFlow: "实体客流一览", // 实体客流一览 List of physical passenger flow
    toDayPassenger: "当日客流", // 当日客流
    toMonthPassenger: "当月客流", // 当月客流
    toYearPassenger: "当年客流", // 当年客流
    totalPassenger: "累计客流", // 累计客流
    passengerFlowPerson: "客流(人)", // 客流(人)
    time: "时间", // 时间
}